/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, createContext } from 'react';

const AuthContext = createContext(0);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);

  return (
    <AuthContext.Provider value={{ token, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
